import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";

const Layout = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  // if token does not exists, then redirect to auth
  // useEffect(() => {
  //   if (!token) {
  //     navigate("/auth/login");
  //   }
  // }, [token]);

  // console.log(JSON.parse(userDetails))
  //   {
  //     "profilepic": "https://cdn3.vectorstock.com/i/thumb-large/32/12/default-avatar-profile-icon-vector-39013212.jpg",
  //     "resetPasswordToken": null,
  //     "notificationToken": null,
  //     "social": null,
  //     "socialId": null,
  //     "fbUid": null,
  //     "twitterLink": null,
  //     "greenbadge": false,
  //     "isUserBlockByAdmin": false,
  //     "_id": "62b3bbe4d0e6530016924657",
  //     "blockedUsers": [],
  //     "created_at": "2022-06-23T01:03:32.679Z",
  //     "userName": "John Doe",
  //     "email": "john@gmail.com",
  //     "mobile": "123321123",
  //     "stripeCustomerId": "cus_LvVToPny07zzhK",
  //     "__v": 0
  //    }

  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
